import BaseService from '@core/class/BaseService';
import { CURRENT_ENV } from '@root/core/configs/env';
import { CommentListRequest, CommentUpload, CreateComment, UpdateComment } from './interface';

class CommentService extends BaseService {
  private endpoint =
    'api/v1/' +
    (process.env.REACT_APP_ROLE === 'seller-admin' ? 'seller' : 'warehouse');

  public getComments = async (params: CommentListRequest) => {
    return this.get(
      `${this.endpoint}/comment-all?group=${params.group}&itemId=${params.itemId}`
    );
  };

  public sendComment = async (body: CreateComment) => {
    return this.post(`${this.endpoint}/comment-all`, body);
  };

  public updateComment = async (id: number, body: UpdateComment) => {
    return this.put(`${this.endpoint}/comment-all/${id}`, body);
  };

  public commentUpload = async (body: CommentUpload) => {
    const form = new FormData();

    if (body.attachments) {
      body.attachments.forEach((file, index) => {
        form.append(`attachments`, file);
      });
    }

    return this.post(`${this.endpoint}/comment-all/upload`, form);
  };

  public rejectedRequest = async (id: number) => {
    return this.post(`${this.endpoint}/comment-all/${id}/reject`);
  };

  public approvedRequest = async (id: number) => {
    return this.post(`${this.endpoint}/comment-all/${id}/approve`);
  };

  public apceptReturn = async (id: number) => {
    return this.put(`${this.endpoint}/returns/${id}/returnToSeller`);
  };

  public editedRequest = async (id: number) => {
    return this.post(`${this.endpoint}/comment-all/${id}/edited`);
  };

  public requestDeleteComment = async (id: number) => {
    return this.post(`${this.endpoint}/comment-all/${id}/request-delete`);
  };

  public deleteComment = async (id: number) => {
    return this.delete(`${this.endpoint}/comment-all/${id}/delete`);
  };
}

export default new CommentService('/', true);
